import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  callAPI,
  getLocalValue,
  IRoleMain,
  LoacalVariables,
  Method,
  toTitleCase,
  TransactionPages
} from "../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { IRows } from "../../Components/Filter/WSFilterComponent";
import { HeaderList } from "../../Components/Header/HeaderList";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import {
  resetDataComponent,
  updateDataComponent
} from "../../StateManagement/actions";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { Refund } from "./Refund";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
export const PaidList: React.FC<any> = () => {
  const [totalCount, setTotalCount] = useState<any>();
  const { add, view, exports } = getPermissions(
    TransactionPages.PaymentList,
    IRoleMain.Transactions
  );
  const [filterChanged, setFilterChanged] = useState<any>(false);
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const columns: IColumns[] = [
    {
      header: "Order#",
      fieldName: "orderNumber",
      type: "default",
      sortable: true,
      sortKey: "OrderNumber"
    },
    {
      header: "Name",
      fieldName: "customerName",
      type: "default"
      // sortable: true,
      // sortKey: "id"
    },

    { header: "Phone", fieldName: "phoneNumber", type: "default" },
    { header: "Is Home Delivery", fieldName: "homeDelivery", type: "default" },
    { header: "Status", fieldName: "orderStatus", type: "status" },
    {
      header: "Ordered On",
      fieldName: "orderDate",
      type: "date",
      sortable: true
    },
    {
      header: "Expected Delivery",
      fieldName: "deliveryDate",
      type: "date",
      sortable: true
    },
    {
      header: "Total Price",
      fieldName: "finalAmount",
      type: "default"
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Generate Bill", "Delivered"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const filterRows: IRows[] = [
    {
      label: "Order#",
      fieldName: "OrderNumber",
      type: "text",
      operator: "like",
      rowDivision: 6
    },
    {
      label: "Customer Name",
      fieldName: "CustomerName",
      type: "text",
      operator: "like",
      rowDivision: 6
    }
  ];

  const source = {
    url: "orders/search",
    page: 1,
    pageSize: 10,
    filter: [
      { field: "OrderStatus", operator: "eq", value: "Paid" }
      // {
      //   field: "FranchiseId",
      //   operator: "eq",
      //   value: getLocalValue(LoacalVariables.FranchiseId)
      // }
    ],
    sort: []
  };

  const transFormData = (data: any, totalCount: any) => {
    setTotalCount(totalCount);
    if (data && data?.length > 0) {
      data?.map((item: any) => {
        item.homeDelivery = item?.isHomeDelivery ? "Yes" : "No";
        item.status = toTitleCase(item.orderStatus);
      });
      return data;
    }
  };

  const updateStatus = async (orderId: any) => {
    const request: any = {
      newStatus: "Delivered",
      updatedBy: "Test"
    };

    const response: any = await callAPI(
      `orders/${orderId}/status`,
      Method.PUT,
      request
    );
    return response;
  };
  const handleAction = async (action: string, row: any) => {
    if (action === "Generate Bill") {
      navigate(`/billing/${row.orderId}`);
    } else if (action === "Delivered") {
      try {
        const response = await updateStatus(row.orderId);
        if (response && response?.message) {
          dispatch(resetDataComponent("paymentPaidGrid"));
          showMessage(
            response.message,
            response.success === true ? "success" : "error"
          );
        }
      } catch (e) {}
    } else if (action === "Refund") {
      const metadataRefund: IMetaData = {
        title: " Tasks",
        hideActions: false,
        content: (props: any, row: any) => (
          <Refund {...props} orderId={row?.orderId} />
        ),
        actions: [
          {
            label: "Cancel",
            // onClick: handleCloseDialog,
            className: "ws-cancel",
            type: "button"
          },
          {
            label: "Submit",
            onClick: handleRefund,
            type: "submit",
            autoFocus: true
          }
        ],
        isDragable: true
      };
      openPopUp(metadataRefund, handleRefund, "40rem");
    }
  };

  const handleRefund = async (data: any) => {
    try {
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent("paymentPaidGrid"));
        showMessage(
          response.message,
          response.success === true ? "success" : "error"
        );
      }
    } catch (e: any) {
      showMessage(e.error);
    }
  };
  const saveData = async (data: any) => {
    const request: any = {
      amountToRefund: data?.amountToRefund,
      paymentMethod: data?.paymentMethod,
      orderId: data?.orderId
    };

    const response: any = await callAPI(
      `payments/refund`,
      Method.POST,
      request
    );
    return response;
  };
  return (
    <>
      <HeaderList
        title="Payments Paid"
        type="card"
        info={`${totalCount || 0} Total Records`}
      />
      {view ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="paymentPaidGrid"
              title="Payments Paid"
              headerType="HaderTopCornered"
              columns={columns}
              filterFields={filterRows}
              source={source}
              transFormData={transFormData}
              isFilterChanged={filterChanged}
            />
          </Grid>
        </Grid>
      ) : (
        <PermissionDenied />
      )}
    </>
  );
};
